import React, { useState, useEffect } from "react";
import "./PrestatairesDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { sendLike } from "../../redux/actions/likeActions";
import { sendDislike } from "../../redux/actions/dislikeActions";
import PrestataireCardLike from "../PrestataireCardLike";

const PrestatairesDashboard = ({ projet }) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth || {});
  const apiUrl = process.env.REACT_APP_API_URL;

  const [prestataire, setPrestataire] = useState(null);
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Charger un prestataire aléatoire pour le projet
  const fetchRandomPrestataire = async () => {
    if (!projet?.idProjetClient) return;
    setLoading(true);
    setPrestataire(null);
    setMessage("");

    try {
      const res = await fetch(
        `${apiUrl}/api/random/prestataire?idProjet=${projet.idProjetClient}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (data.success) {
        setPrestataire(data.prestataire);
        setType(data.type);
      } else {
        setMessage(data.message || "Aucun prestataire compatible trouvé.");
      }
    } catch (error) {
      console.error("Erreur fetch prestataire :", error);
      setMessage("Erreur lors du chargement du prestataire.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Appel automatique quand le projet change
  useEffect(() => {
    if (projet?.idProjetClient) {
      fetchRandomPrestataire();
    }
  }, [projet]);

  // ✅ Like
  const handleLike = () => {
    if (!prestataire || !projet) return;
    dispatch(sendLike(projet.idProjetClient, prestataire.idPrestataire, token));
    fetchRandomPrestataire();
  };

  // ✅ Pass
  const handlePass = () => {
    if (!prestataire || !projet) return;
    dispatch(sendDislike(prestataire.idUser, projet.idProjetClient, token));
    fetchRandomPrestataire();
  };

  return (
    <div className="prestataires-dashboard">
      {loading && <p className="status">Chargement...</p>}

      {!loading && prestataire && (
        <><h3 style={{ textAlign: "center" }}>
          {type === "like_received"
            ? "Bonne nouvelle ! Ce prestataire est intéressé par votre projet"
            : "Découvrez un prestataire compatible avec votre projet"}
        </h3>

          <PrestataireCardLike
            prestataire={prestataire}
            projet={projet}
            apiUrl={apiUrl}
            onLike={handleLike}
            onPass={handlePass}
            isReceivedLike={type === "like_received"}
          /></>
      )}

      {!loading && !prestataire && message && (
        <div className="empty">
          <p>{message}</p>
          <button className="reload" onClick={fetchRandomPrestataire}>
            🔄 Recharger
          </button>
        </div>
      )}
    </div>
  );
};

export default PrestatairesDashboard;
